import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query getDeadlineContracts($where: DeadlineContractWhereInput, $limit: Int, $offset: Int) {\n    deadlineContracts(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query getDeadlineContracts($where: DeadlineContractWhereInput, $limit: Int, $offset: Int) {\n    deadlineContracts(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcDeadlineContractOutlinedSelectComponent = /** @class */ (function () {
    function FcDeadlineContractOutlinedSelectComponent(apollo) {
        this.apollo = apollo;
    }
    FcDeadlineContractOutlinedSelectComponent.prototype.searchDeadlineContracts = function (searchTerm, limit, offset) {
        return this.apollo
            .query({
            query: SEARCH_QUERY,
            variables: {
                where: {
                    archived: false,
                    name_contains: searchTerm
                },
                limit: limit,
                offset: offset
            }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['deadlineContracts']['items'];
        }));
    };
    return FcDeadlineContractOutlinedSelectComponent;
}());
export { FcDeadlineContractOutlinedSelectComponent };
var templateObject_1;
